import React from "react";
import styled from 'styled-components';
import PageTitle from "../components/PageSEO";
import Presentation from "./Presentation";
import Simulator from "./Simulator";
import SankeyChart from "./SankeyChart";
import SelectionPanel from "./SelectionPanel";

const LandingPageComponent = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(1200px 700px at 20% 0%, rgba(38, 179, 168, 0.14), transparent 60%),
    radial-gradient(1000px 700px at 95% 10%, rgba(15, 45, 44, 0.10), transparent 55%),
    var(--bg);
`;

const TopNav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(10px);
  background: rgba(251, 251, 252, 0.7);
  border-bottom: 1px solid var(--border);
`;

const TopNavInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 12px 6vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Brand = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  font-weight: 750;
  letter-spacing: -0.02em;

  span {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, var(--accent), var(--primary));
    box-shadow: 0 0 0 4px rgba(38, 179, 168, 0.12);
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-end;

  a {
    text-decoration: none;
    padding: 8px 10px;
    border-radius: 999px;
    color: var(--muted);
    font-weight: 650;
    font-size: 0.95rem;
  }

  a:hover {
    background: rgba(255, 255, 255, 0.6);
    color: var(--text);
  }
`;

const Section = styled.section`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  padding: clamp(56px, 9vh, 96px) 6vw;
`;

const SectionInner = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.35rem, 2.2vw + 0.7rem, 2rem);
  line-height: 1.15;
  color: var(--text);
  letter-spacing: -0.02em;
`;

const SectionLead = styled.p`
  margin: 0;
  max-width: 75ch;
  line-height: 1.6;
  color: var(--muted);
`;

const Footer = styled.footer`
  padding: 56px 6vw;
  border-top: 1px solid var(--border);
  color: var(--muted);

  div {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 10px 18px;
    align-items: center;
    justify-content: space-between;
  }

  a {
    text-decoration: none;
    font-weight: 650;
  }

  a:hover {
    text-decoration: underline;
  }
`;

function VotoDesperdicado() {
  return (
    <LandingPageComponent>
      <PageTitle
        title="Voto Desperdiçado"
        description="Descobre, em 1 minuto, se o teu voto elege deputados — e porque é que tantos votos acabam por não contar."
        canonical="/voto-desperdicado"
      />

      <TopNav aria-label="Navegação">
        <TopNavInner>
          <Brand href="#topo">
            <span aria-hidden="true" />
            Voto desperdiçado
          </Brand>
          <NavLinks>
            <a href="#selecao">Explorar</a>
            <a href="#simulador">Simulador</a>
            <a href="#visualizacao">Visualização</a>
          </NavLinks>
        </TopNavInner>
      </TopNav>

      <section id="topo">
        <Presentation />
      </section>

      <Section id="selecao" aria-labelledby="selecao-title">
        <SectionInner>
          <SectionTitle id="selecao-title">Explora por partido ou por círculo</SectionTitle>
          <SectionLead>
            Alterna entre <strong>Partidos</strong> e <strong>Círculos</strong> para veres exemplos rápidos — e depois experimenta o simulador para o teu caso.
          </SectionLead>
          <SelectionPanel />
        </SectionInner>
      </Section>

      <Section id="simulador" aria-labelledby="simulador-title">
        <SectionInner>
          <SectionTitle id="simulador-title">Simulador (1 minuto)</SectionTitle>
          <SectionLead>
            Seleciona o teu <strong>círculo eleitoral</strong> e o <strong>partido</strong> em que votaste. Explicamos, de forma simples, se esse voto contribuiu
            para eleger deputados.
          </SectionLead>
          <Simulator />
        </SectionInner>
      </Section>

      <Section id="visualizacao" aria-labelledby="visualizacao-title">
        <SectionInner>
          <SectionTitle id="visualizacao-title">Visualização</SectionTitle>
          <SectionLead>
            Uma visão global para perceberes como os votos se convertem (ou não) em mandatos. Complementa o simulador — começa por simular o teu caso.
          </SectionLead>
          <SankeyChart />
        </SectionInner>
      </Section>

      <Footer>
        <div>
          <span>Projeto: Voto Desperdiçado · Dados: Legislativas 2022</span>
          <span>
            <a href="#topo">Voltar ao topo</a>
          </span>
        </div>
      </Footer>
    </LandingPageComponent>
  );
}

export default VotoDesperdicado;
